import { Link } from "react-router-dom";
import Navbar from "@/components/layout/Navbar";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-bone">
      <Navbar />
      <div className="max-w-[800px] mx-auto px-6 py-24 text-center">
        <div className="overline">// 404</div>
        <h1 className="font-display font-black text-7xl uppercase tracking-tighter mt-4">Page not found</h1>
        <p className="text-muted-foreground mt-4">The URL you visited doesn't exist on LeadTitan.</p>
        <Link to="/" className="brut-btn-primary mt-8 inline-flex" data-testid="back-home">Back to home</Link>
      </div>
    </div>
  );
}
